/** 設定を保存していない端末で最初に表示するお知らせです。 */
export const DEFAULT_ANNOUNCEMENTS = [
  "まもなく前夜祭が始まります。開始までそのままお待ちください。",
] as const satisfies readonly string[];

export const MAX_ANNOUNCEMENTS = 5;
export const MAX_ANNOUNCEMENT_LENGTH = 200;
